import { useEffect, useRef } from "react";
import { Link, Navigate, useLocation, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { groupOf, lastTab, visibleTabs } from "../../lib/nav";

export const Breadcrumbs = ({ items }) => (
  <nav className="flex flex-wrap items-center gap-1 text-xs text-[#8C867A]" data-testid="breadcrumbs" aria-label="breadcrumb">
    {items.map(([l, to], i) => (
      <span key={l} className="flex items-center gap-1">{i > 0 && <ChevronRight size={12} />}
        {to ? <Link to={to} className="hover:text-[#E8643C]" data-testid={`crumb-${i}`}>{l}</Link> : <span className="font-semibold text-[#111]" data-testid={`crumb-${i}`}>{l}</span>}</span>))}
  </nav>
);

export const Hub = ({ group, elements }) => {
  const { tab } = useParams();
  const { user } = useAuth();
  const loc = useLocation();
  const g = groupOf(group);
  const tabs = visibleTabs(g, user);
  const cur = tabs.find((t) => t.k === tab);
  const act = useRef(null);
  useEffect(() => { if (cur) localStorage.setItem(`hub-last-${group}`, cur.k); act.current?.scrollIntoView({ inline: "center", block: "nearest" }); }, [cur, group]);
  if (!tabs.length) return <Navigate to="/" replace />;
  if (!cur) {
    const last = tabs.find((t) => t.k === lastTab(group)) || tabs[0];
    return <Navigate to={{ pathname: `/${group}/${last.k}`, search: loc.search }} replace />;
  }
  return (
    <div data-testid={`hub-${group}`}>
      <div className="sticky top-16 z-20 border-b border-[#E2DDD5] bg-[#F2F0EC]/90 px-4 pt-3 backdrop-blur-md sm:px-6 lg:px-10">
        <Breadcrumbs items={[["Inicio", "/"], [g.l, `/${group}`], [cur.l]]} />
        <div className="no-scrollbar edge-fade mt-2 flex gap-1 overflow-x-auto pb-2 pr-6" data-testid={`hub-tabs-${group}`}>{tabs.map((t) => (
          <Link key={t.k} ref={t.k === cur.k ? act : null} to={`/${group}/${t.k}`} data-testid={`hub-tab-${group}-${t.k}`}
            className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${t.k === cur.k ? "bg-[#111] text-white" : "text-[#5C5850] hover:bg-white"}`}>{t.l}</Link>))}</div>
      </div>
      <div key={cur.k} style={{ animation: "rise .25s ease-out both" }}>{elements[cur.k]}</div>
    </div>
  );
};
